import React from 'react';
import {ReviewAccountButton} from "../../Assets/svg";
import {useDispatch, useSelector} from "react-redux";
import {requestTableDataReview, reviewAccountAction} from "../Store/ReviewAccountsStore";


const RightSection = () => {


    const data = useSelector(s => s.reviewAccountReducer);
    const filters = JSON.stringify(data.filterValues)


    const dispatch = useDispatch()


    const group = data.handlerButton.group
    const kol = data.handlerButton.kol
    const moein = data.handlerButton.moein
    const tafsili = data.handlerButton.tafsili
    const sendRequestGet4Datas = ({level = 2}) => {
      const prevLevel = ''
      const accountCode = ''
      const passedLevels = [level]
      // const passedAccounts = data.passedAccounts
      const passedAccounts = []

      dispatch(reviewAccountAction.fillInput({
        accountCode, prevLevel,
        isItFirstTimeToRequestLink: true,
      }))
      dispatch(
        requestTableDataReview(
          {
            level,
            prevLevel,
            accountCode,
            passedLevels,
            passedAccounts,
            filters
          }
        )
      )
    }

    const spacialButton = (level) => {

      const currentLevel = data.myData.currentLevel;


      const prevLevel = data.prevLevel
      const accountCode = data.accountCode
      const mode = data.mode
      const downToUpType = data.downToUpType
      const passedLevels = data.myData.passedLevels
      const passedAccounts = data.passedAccounts

      let path;

      if (data.isItFirstTimeToRequestLink) {

        const ddd = JSON.parse(localStorage.getItem("lastRequestPayload"));
        path = [ddd]
        dispatch(reviewAccountAction.fillInput({
          isItFirstTimeToRequestLink: false
        }))
      } else {
        path = data?.myData?.path;
      }



      dispatch(
        requestTableDataReview(
          {
            level,
            prevLevel,
            accountCode,
            mode,
            downToUpType,
            passedLevels,
            passedAccounts,
            path,
            filters
          }))

    }


    const tafsiliClickHandler = () => {
      spacialButton(3)
    }
    const moeinClickHandler = () => {
      spacialButton(2)
    }
    const kolClickHandler = () => {
      spacialButton(1)
    }
    const groupClickHandler = () => {
      spacialButton(0)
    }


    return (
      <div
        className={'right__section'}
      >
        <div>
          <div className={'btn__and__icon'}>
            <button
              className={'w-100 btn btn__secondary_purple font__size__10'}
              onClick={() => sendRequestGet4Datas({level: 0})}
            >
              گروه
            </button>
            <div>{data.showHandlers &&
              <div
                className={group ? '' : 'opacity-20'}
                onClick={group ? groupClickHandler : ""}
              >
                <ReviewAccountButton
                />
              </div>}</div>
          </div>
          <div className={'btn__and__icon'}>
            <button
              className={'w-100 btn btn__secondary_purple font__size__10'}
              onClick={() => sendRequestGet4Datas({level: 1})}
            >
              کل
            </button>
            <div>{data.showHandlers &&
              <div
                className={kol ? '' : 'opacity-20'}
                onClick={kol ? kolClickHandler : ""}
              >
                <ReviewAccountButton/>
              </div>
            }
            </div>
          </div>
          <div className={'btn__and__icon'}>
            <button
              className={'w-100 btn btn__secondary_purple font__size__10'}
              onClick={() => sendRequestGet4Datas({level: 2})}

            >
              معین
            </button>
            <div>
              {data.showHandlers &&
                <div
                  className={moein ? '' : 'opacity-20'}
                  onClick={moein ? moeinClickHandler : ""}
                >
                  <ReviewAccountButton

                  />
                </div>
              }
            </div>
          </div>
          <div className={'btn__and__icon'}>
            <button
              onClick={() => sendRequestGet4Datas({level: 3})}

              className={'w-100 btn btn__secondary_purple font__size__10'}
            >
              تفصیلی
            </button>
            <div>
              {data.showHandlers &&
                <div
                  className={tafsili ? '' : 'opacity-20'}
                  onClick={tafsili ? tafsiliClickHandler : ""}
                >
                  <ReviewAccountButton

                  />
                </div>
              }
            </div>
          </div>

        </div>
      </div>
    );
  }
;

export default RightSection;
